$(document).on('click.mainNavToggle','#main-nav-toggle',function(e){$('body').toggleClass('is-main-nav-open');$(e.currentTarget).toggleClass('active');});